module.exports = __webpack_public_path__ + "static/media/certificate.e0126a68.png";